import { useState, useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Dialog,
  DialogPanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
// import {
//   faFileCirclePlus,
//   faFilePen,
//   faUserGear,
//   faUserPlus,
//   faRightFromBracket,
// } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSendLogoutMutation } from "../features/auth/authApiSlice";
import useAuth from "../hooks/useAuth";
// import PulseLoader from "react-spinners/PulseLoader";
// import { ChevronDownIcon, ChevronLeftIcon } from "@heroicons/react/20/solid";

// const DASH_REGEX = /^\/dash(\/)?$/;
// const NOTES_REGEX = /^\/dash\/notes(\/)?$/;
// const USERS_REGEX = /^\/dash\/users(\/)?$/;

//KOMPONENTA SE KORISTI SAMO KAD SE ULOGUJE A U LOGIN JE CUSTOM
const DashHeader = () => {
  //email, roles, status, isKlijent, isAdmin, id, jmbg
  const { isAdmin, id } = useAuth();

  // console.log(email, roles, status, isKlijent, isAdmin, id, jmbg);

  const navigate = useNavigate();
  // const { pathname } = useLocation();

  const [sendLogout, { isLoading, isSuccess, isError, error }] =
    useSendLogoutMutation();

  useEffect(() => {
    if (isSuccess) navigate("/"); //ili /login ako hocu u login da se navigira posle logout-a
  }, [isSuccess, navigate]);

  //Admin links
  const vidiDash = () => navigate("/dash");
  const userLista = () => navigate(`/dash/users`);
  const vidiChat = () => navigate("/dash/chat");
  const vidiPodesavanja = () => navigate("/dash/podesavanja");
  const vidiKalkulacije = () => navigate("/dash/kalkulacije");
  const vidiMojDnevnik = () => navigate("/dash/mojdnevnik");
  const vidiPretplate = () => navigate("/dash/sviPaketi");
  const vidiBlog = () => navigate("/dash/blogs");
  const vidiBlogAdmin = () => navigate("/dash/blogsAdmin");

  //User links
  const vidiProfilKlijenta = () => navigate(`/dash/user/${id}`);
  //const vidiBlog = () => navigate("/dash/blog");

  //OVAJ KORISTIM
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const AdminNav = [
    // { name: "Profil", action: vidiProfilKlijenta },
    { name: "Dashboard", href: `/dash` }, //Ovako ce mo
    { name: "Klijenti", href: "/dash/users" },
    { name: "Blog", href: "/dash/blogsAdmin" },
    { name: "Chat", href: "/dash/chat" },
    { name: "Settings", href: "/dash/podesavanja" },
  ];

  const KlijentNav = [
    // { name: "Profil", action: vidiProfilKlijenta },
    { name: "Profil", href: `/dash/user/${id}` }, //Ovako ce mo
    { name: "Moj dnevnik", href: "/dash/mojdnevnik" },
    { name: "Kalkulatori", href: "/dash/kalkulacije" },
    { name: "Blog", href: "/dash/blogs" },
    { name: "Pretplate", href: "/dash/sviPaketi" },
  ];

  const headerDiv = (
    <>
      <header
        className="inset-x-0 top-0 z-50 bg-veljko-blue"
        style={{ backgroundColor: "#66BB6A" }}
      >
        <nav
          className="mx-auto flex w-full items-center justify-between p-1 lg:px-2"
          aria-label="Global"
        >
          <div className="flex flex-1 items-center">
            {/* Logo */}
            <a
              href={`https://nutritrans.rs/dash/user/${id}`}
              className="-m-1.5 p-1.5 flex-shrink-0"
            >
              <span className="sr-only">Your Company</span>
              <img
                className="w-10 h-auto mr-2"
                src={`${process.env.PUBLIC_URL}/logoo.png`}
                alt="Your Company"
              />
            </a>

            {/* Navigation links to the left of the logo */}
            {/* <div className="hidden lg:flex lg:gap-x-8 mr-6">
              {isAdmin ? (
                <>
                  <button
                    className="text-sm font-semibold leading-6 text-white"
                    onClick={vidiDash}
                  >
                    Dashboard
                  </button>
                  <button
                    className="text-sm font-semibold leading-6 text-white"
                    onClick={userLista}
                  >
                    Klijenti
                  </button>
                  <button
                    className="text-sm font-semibold leading-6 text-white"
                    onClick={vidiChat}
                  >
                    Chat
                  </button>
                  <button
                    className="text-sm font-semibold leading-6 text-white"
                    onClick={vidiPodesavanja}
                  >
                    Settings
                  </button>
                </>
              ):
              <>
                <button
                  href="#"
                  className="ml-2 text-sm font-semibold leading-6 text-white"
                  onClick={vidiProfilKlijenta}
                >
                  Profil
                </button>
                <button
                  href="#"
                  className="text-sm font-semibold leading-6 text-white"
                  onClick={vidiMojDnevnik}
                >
                  Moj dnevnik
                </button>
                <button
                  href="#"
                  className="text-sm font-semibold leading-6 text-white"
                  onClick={vidiKalkulacije}
                >
                  Kalkulisanje
                </button>
                <button
                  href="#"
                  className="text-sm font-semibold leading-6 text-white"
                >
                  Blog
                </button>
              </>
              }

            </div> */}
          </div>

          {/* Mobile menu button */}
          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>

          {/* Admin menu for large screens */}
          <div className="hidden lg:flex lg:flex-1 lg:justify-end">
            <div className="hidden lg:flex lg:gap-x-6 mr-4">
              {isAdmin ? (
                <>
                  <button
                    className="text-sm font-semibold leading-6 text-black"
                    onClick={vidiDash}
                  >
                    Dashboard
                  </button>
                  <button
                    className="text-sm font-semibold leading-6 text-black"
                    onClick={userLista}
                  >
                    Klijenti
                  </button>
                  <button
                    className="text-sm font-semibold leading-6 text-black"
                    onClick={vidiBlogAdmin}
                  >
                    Blog
                  </button>
                  <button
                    className="text-sm font-semibold leading-6 text-black"
                    onClick={vidiChat}
                  >
                    Chat
                  </button>
                  <button
                    className="text-sm font-semibold leading-6 text-black"
                    onClick={vidiPodesavanja}
                  >
                    Settings
                  </button>
                </>
              ) : (
                <>
                  <button
                    href="#"
                    className="ml-2 text-sm font-semibold leading-6 text-black"
                    onClick={vidiProfilKlijenta}
                  >
                    Profil
                  </button>
                  <button
                    href="#"
                    className="text-sm font-semibold leading-6 text-black"
                    onClick={vidiMojDnevnik}
                  >
                    Moj dnevnik
                  </button>
                  <button
                    href="#"
                    className="text-sm font-semibold leading-6 text-black"
                    onClick={vidiKalkulacije}
                  >
                    Kalkulatori
                  </button>
                  <button
                    onClick={vidiBlog} //here 12
                    className="text-sm font-semibold leading-6 text-black"
                  >
                    Blog
                  </button>
                  <div className="border-l border-black h-8 mx-2" />
                </>
              )}
            </div>

            <Menu as="div" className="relative">
              <MenuButton className="-m-1.5 flex items-center p-1.5">
                <span className="sr-only">Open user menu</span>
                <img
                  className="h-8 w-8 rounded-full"
                  src={`${process.env.PUBLIC_URL}/img/profil.png`}
                  alt="Profile"
                />
              </MenuButton>
              <Transition
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                {isAdmin ? (
                  <MenuItems className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                    {/* <MenuItem className="block px-3 py-1 text-sm leading-6 text-gray-900">
                    <a
                      className="block px-3 py-1 text-sm leading-6 text-gray-900"
                      style={{ cursor: "pointer" }}
                    >
                      Planovi ishrane
                    </a>
                  </MenuItem> */}
                    <MenuItem className="block px-3 py-1 text-sm leading-6 text-gray-900">
                      <a
                        className="block px-3 py-1 text-sm leading-6 text-gray-900"
                        style={{ cursor: "pointer" }}
                      >
                        Podešavanja
                      </a>
                    </MenuItem>
                    <MenuItem className="block px-3 py-1 text-sm leading-6 text-gray-900">
                      <a
                        onClick={sendLogout}
                        className="block px-3 py-1 text-sm leading-6 text-gray-900"
                        style={{ cursor: "pointer" }}
                      >
                        Izloguj se
                      </a>
                    </MenuItem>
                  </MenuItems>
                ) : (
                  <MenuItems className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                    <MenuItem className="block px-3 py-1 text-sm leading-6 text-gray-900">
                      <a
                        onClick={vidiProfilKlijenta}
                        className="block px-3 py-1 text-sm leading-6 text-gray-900"
                        style={{ cursor: "pointer" }}
                      >
                        Profil
                      </a>
                    </MenuItem>
                    <MenuItem className="block px-3 py-1 text-sm leading-6 text-gray-900">
                      <a
                        onClick={vidiPretplate}
                        className="block px-3 py-1 text-sm leading-6 text-gray-900"
                        style={{ cursor: "pointer" }}
                      >
                        Pretplate
                      </a>
                    </MenuItem>
                    <MenuItem className="block px-3 py-1 text-sm leading-6 text-gray-900">
                      <a
                        onClick={sendLogout}
                        className="block px-3 py-1 text-sm leading-6 text-gray-900"
                        style={{ cursor: "pointer" }}
                      >
                        Izloguj se
                      </a>
                    </MenuItem>
                  </MenuItems>
                )}
              </Transition>
            </Menu>
          </div>
        </nav>

        {/* Mobile menu dialog */}
        <Dialog
          className="lg:hidden"
          open={mobileMenuOpen}
          onClose={setMobileMenuOpen}
        >
          <div className="fixed inset-0 z-50" />
          <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <a href="#" className="-m-1.5 p-1.5">
                <img
                  className="w-10 h-auto"
                  src={`${process.env.PUBLIC_URL}/logoo.png`}
                  alt="Your Company"
                />
              </a>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                {isAdmin ? (
                  <div className="space-y-2 py-6">
                    {AdminNav.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                ) : (
                  <div className="space-y-2 py-6">
                    {KlijentNav.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                )}

                <div className="py-6">
                  <a
                    onClick={sendLogout}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                    style={{ cursor: "pointer" }}
                  >
                    Izloguj se
                  </a>
                </div>
              </div>
            </div>
          </DialogPanel>
        </Dialog>
      </header>
    </>
  );

  return headerDiv;
};
export default DashHeader;

// <header className="fixed inset-x-0 top-0 z-50 bg-blue-500">

// <nav
//   className="mx-auto flex w-full items-center justify-between p-1 lg:px-8"
//   aria-label="Global"
// >
//   <div className="flex lg:flex-1">
//     <a href="#" className="-m-1.5 p-1.5">
//       <span className="sr-only">Your Company</span>
//       <img
//         className="w-14 h-auto"
//         src={`${process.env.PUBLIC_URL}/img/logo.png`}
//         alt="Your Company"
//       />
//     </a>
//   </div>
//   <div className="flex lg:hidden">
//     <button
//       type="button"
//       className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white" // Changed text color to white for better contrast
//       onClick={() => setMobileMenuOpen(true)}
//     >
//       <span className="sr-only">Open main menu</span>
//       <Bars3Icon className="h-6 w-6" aria-hidden="true" />
//     </button>
//   </div>
//   <div className="hidden lg:flex lg:gap-x-12">
//     {/* Navigation items */}
//   </div>
//   <div className="hidden lg:flex lg:flex-1 lg:justify-end">
//     {/* <a href="#" className="text-sm font-semibold leading-6 text-white">
//       <a onClick={sendLogout}>Logout</a>
//       <span aria-hidden="true">&rarr;</span>
//     </a> */}

//     <Menu as="div" className="relative">
//       <MenuButton className="-m-1.5 flex items-center p-1.5">
//         <span className="sr-only">Open user menu</span>
//         <img
//           className="h-8 w-8 rounded-full bg-gray-50"
//           src={`${process.env.PUBLIC_URL}/img/profil.jpg`}
//           alt="Profil slika"
//         />
//         <span className="hidden lg:flex lg:items-center">
//           <span
//             className="ml-4 text-sm font-semibold leading-6 text-gray-900"
//             aria-hidden="true"
//           >
//             {/* {username === 'Admin' ? username : username - status}  */}
//             {/* {username} */}
//           </span>
//           <ChevronDownIcon
//             className="ml-2 h-5 w-5 text-gray-400"
//             aria-hidden="true"
//           />
//         </span>
//       </MenuButton>
//       <Transition
//         enter="transition ease-out duration-100"
//         enterFrom="transform opacity-0 scale-95"
//         enterTo="transform opacity-100 scale-100"
//         leave="transition ease-in duration-75"
//         leaveFrom="transform opacity-100 scale-100"
//         leaveTo="transform opacity-0 scale-95"
//       >
//         {/* Nav user options */}
//         <MenuItems className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
//           {/* VIDE SAMO ODREDJENI */}
//           {/* {isAdmin || isManager ?
//                         <MenuItem className='block px-3 py-1 text-sm leading-6 text-gray-900' onClick={()=>console.log("Tvoj profil")}>
//                             <a onClick={vidiProfil} className={'block px-3 py-1 text-sm leading-6 text-gray-900'} style={{cursor: "pointer"}}>Tvoj profil</a>
//                         </MenuItem> :
//                         ""
//                     } */}
//           {/* ZA SAD SVI VIDE SVOJ PROFIL, NE ZABORAVI DA PROEMNIS PERMISIJE U APP.JS */}

//           {/* {
//                         roles[0] === "Editor" ?
//                             <MenuItem className='block px-3 py-1 text-sm leading-6 text-gray-900' onClick={()=>console.log("Tvoj profil")}>
//                                 <a onClick={vidiProfil} className={'block px-3 py-1 text-sm leading-6 text-gray-900'} style={{cursor: "pointer"}}>Tvoj profil</a>
//                             </MenuItem>
//                         : ""
//                     } */}

//           <MenuItem className="block px-3 py-1 text-sm leading-6 text-gray-900">
//             <a
//               // onClick={sendLogout}
//               className={
//                 "block px-3 py-1 text-sm leading-6 text-gray-900"
//               }
//               style={{ cursor: "pointer" }}
//             >
//               Planovi ishrane
//             </a>
//           </MenuItem>
//           <MenuItem className="block px-3 py-1 text-sm leading-6 text-gray-900">
//             <a
//               // onClick={sendLogout}
//               className={
//                 "block px-3 py-1 text-sm leading-6 text-gray-900"
//               }
//               style={{ cursor: "pointer" }}
//             >
//               Pretplata
//             </a>
//           </MenuItem>
//           <MenuItem className="block px-3 py-1 text-sm leading-6 text-gray-900">
//             <a
//               onClick={sendLogout}
//               className={
//                 "block px-3 py-1 text-sm leading-6 text-gray-900"
//               }
//               style={{ cursor: "pointer" }}
//             >
//               Izloguj se
//             </a>
//           </MenuItem>
//         </MenuItems>
//       </Transition>
//     </Menu>
//   </div>
// </nav>
// <Dialog
//   className="lg:hidden"
//   open={mobileMenuOpen}
//   onClose={setMobileMenuOpen}
// >
//   <div className="fixed inset-0 z-50" />
//   <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
//     <div className="flex items-center justify-between">
//       <a href="#" className="-m-1.5 p-1.5">
//         <img
//           className="w-24 h-auto"
//           src={`${process.env.PUBLIC_URL}/img/logo.png`}
//           alt="Your Company"
//         />
//       </a>
//       <button
//         type="button"
//         className="-m-2.5 rounded-md p-2.5 text-gray-700"
//         onClick={() => setMobileMenuOpen(false)}
//       >
//         <span className="sr-only">Close menu</span>
//         <XMarkIcon className="h-6 w-6" aria-hidden="true" />
//       </button>
//     </div>
//     <div className="mt-6 flow-root">
//       <div className="-my-6 divide-y divide-gray-500/10">
//         <div className="space-y-2 py-6">
//           {navigation.map((item) => (
//             <a
//               key={item.name}
//               href={item.href}
//               className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
//             >
//               {item.name}
//             </a>
//           ))}
//         </div>
//         <div className="py-6">
//           <a
//             href="#"
//             className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
//           >
//             Log in
//           </a>
//         </div>
//       </div>
//     </div>
//   </DialogPanel>
// </Dialog>
// </header>
